<template>
  <span> 

        <v-tooltip v-model="show" bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn :loading="buttonLoad" v-on="{tooltip}" @click.stop="listDialogOwnership=true;getOwnership()" :color="iconColor" text icon >
                <v-icon small>{{icon}}</v-icon>
            </v-btn>               
          </template>
          <span>{{tooltipText}}</span>
        </v-tooltip>             
        <v-dialog v-model="listDialogOwnership"  max-width="1000">
            <v-card class="px-7" style="background: #121212;" >
              <v-row>
                <v-col cols="12">
                  <v-card-title>
                    {{tooltipText}}
                    <v-spacer></v-spacer>
                    <v-btn color="primary" icon @click="listDialogOwnership = false">
                        <v-icon color="white" small>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                </v-col>
                <v-col cols="12">
                  <v-skeleton-loader v-if="!firstLoadDone" type="table"></v-skeleton-loader>
                  <v-data-table
                    v-if="firstLoadDone"
                    :headers="headers"
                    :items="listPortfolios"
                    :mobile-breakpoint="0"
                    dense
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td>
                          <v-btn
                            class="px-2 mr-2"
                            color="primary"
                            min-width="0"
                            icon
                            small
                            :to="'/portfolio/analyze/' + row.item.id"       
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">
                                  mdi-magnify-plus-outline
                                </v-icon>                        
                              </template>
                              <span>Analyze</span>
                            </v-tooltip> 
                          </v-btn>
                        </td>
                        <td><b>{{row.item.name}}</b><br>
                          <small>{{row.item.mnemonic}}  | {{row.item.currency}} | Strat: {{row.item.strategy}}</small>  <br>

                        </td>
                        <td>
                            <div :color="getIconColor(row.item.owned)" v-if="row.item.owned>=1">{{getFormatPosition(row.item.wgt_scheme_is_wgt,row.item.quantity)}}</div>
                            <v-icon small v-else  dark :color="getIconColor(row.item.owned)">{{getIconValue(row.item.owned)}}</v-icon>
                        </td>
                        <td>

                          <v-chip
                            small
                            v-if="row.item.owned"
                            outlined
                          >
                            Owned
                          </v-chip>                                     
                          <v-chip
                            :style="'background-color: #00a1c9 !important;'"  small
                            v-if="row.item.is_investable & !row.item.owned"
                          >
                            <v-avatar left>
                              <v-icon>mdi-checkbox-marked-circle</v-icon>
                            </v-avatar>
                            Suitable
                          </v-chip>      
                          <v-menu
                            v-if="!row.item.is_investable & !row.item.owned"
                          
                            bottom
                            right
                            transition="scale-transition"
                            origin="top left"
                          >
                            <template v-slot:activator="{ on }">
                              <v-chip
                              v-on="on"
                                :style="'background-color: #dd3f5b !important;'"  small
                              >
                                <v-avatar left>
                                  <v-icon>mdi-close</v-icon>
                                </v-avatar>
                                Not Suitable
                              </v-chip>
                            </template>
                            <v-card width="300">
                              <v-list dark>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title> {{stock}} in {{row.item.mnemonic}}</v-list-item-title>
                                    <v-list-item-subtitle>Low suitability</v-list-item-subtitle>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-btn
                                      icon
                                      @click="menu = false"
                                    >
                                      <v-icon>mdi-close-circle</v-icon>
                                    </v-btn>
                                  </v-list-item-action>
                                </v-list-item>
                              </v-list>
                              <v-list>
                                <v-list-item >
                                  <v-list-item-content v-if="row.item.des">{{row.item.des}}</v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-card>
                          </v-menu>

                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-card-actions>    
                <v-spacer></v-spacer>             
                <v-btn color="primary" text @click="listDialogOwnership = false">Close</v-btn>
              </v-card-actions>
            </v-card>                
        </v-dialog>
    </span>
</template>

<script>
export default {
  name: "StockPortfolioOwnership",
  props: {
    stock: String,
    ownership: Number
    // ownership: {
    //   type: Number,
    //   default: 0
    // }   
  },
  data() {
    return {
      listDialogOwnership:false,
      listPortfolios:[],
      ownershipValue: null,
      buttonLoad: false,
      errorbar: false,
      firstLoadDone: false,
      icon: "mdi-briefcase-remove-outline",
      iconColor:"white",
      icon_neutral: "mdi-briefcase-remove-outline",
      icon_neutral_color:"white",

      icon_owned: "mdi-briefcase-check-outline",
      icon_owned_color:"primary",      
    
      icon_delete: "white",
      tooltipText: "Your ownership of the stock",
      show:false,
      headers: [
        {
          sortable: false,
          text: '',
          align: 'left',
        },
        {
          text: 'Portfolio',
          value: 'name',
          class: 'text-no-wrap'
        },
        {
          text: 'Position',
          align: 'left',
          value: 'quantity',
        },
        { text: 'Suitability', 
          value: 'is_investable', 
          class: 'text-no-wrap' },
      ],      
    };
  },
  mounted() {
    if (this.ownership) {
      this.ownershipValue = this.ownership;
      this.checkIconValue();
    }
    else {
      //console.log("load")
      this.getOwnership();
    }
  },
  methods: {
    getFormatPosition(wgt_scheme_is_wgt,quantity) {
      if (wgt_scheme_is_wgt==0) {
        return quantity + " shares"
      } else {
        return Math.round(quantity *10000)/100 +"%"
      }
    },
    checkIconValue() {
      if (this.ownershipValue==0) {
          this.icon = this.icon_neutral;
          this.iconColor = this.icon_neutral_color;
          this.tooltipText="You do not own this stock"
      } else if (this.ownershipValue>0) {
          this.icon = this.icon_owned;
          this.iconColor = this.icon_owned_color;
          this.tooltipText="You own this stock in " + this.ownershipValue + " portfolio" + ((this.ownershipValue>1) ? 's' : '')
      } 
    },
    getIconValue(owned) {
      if (owned==0) {
          return this.icon_neutral;
      } else if (owned>0) {
          return this.icon_owned;
      } 
    },
    getIconColor(owned) {
      if (owned==0) {
          return this.icon_neutral_color;
      } else if (owned>0) {
          return this.icon_owned_color;
      } 
    },    
    async getOwnership() {
      if (this.firstLoadDone) {
        return 1;
      }
      var self = this;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .get(process.env.VUE_APP_API_HOST + "/get-user-ownership/" + self.stock, {
          headers: {
            Authorization: currentToken,
            "Content-Type": "application/json"
          }
        })
        .then(function(response) {
          self.listPortfolios = response.data.ownership;
          self.ownershipValue = response.data.owned;
          //self.ratingValue=action;
          self.checkIconValue();
          self.buttonLoad = false;
          self.firstLoadDone=true;          
        })
        .catch(function(error) {
          self.buttonLoad = false;
          self.listPortfolios =[];
          //console.log(error.response.data);          
          self.tooltipText = error.response.data.errorMessage;
          self.show=true;
          self.firstLoadDone=true;                
        });

    },    
    // async setPreference(action,url) {
    //   //console.log(url);
    //   var self = this;
    //   const currentSession = await this.$Amplify.Auth.currentSession();
    //   const currentToken = currentSession.getIdToken().getJwtToken();
    //   this.$http
    //     .get(process.env.VUE_APP_API_HOST + url + self.stock, {
    //       headers: {
    //         Authorization: currentToken,
    //         "Content-Type": "application/json"
    //       }
    //     })
    //     .then(function(response) {
    //       self.message = response.data.message;
    //       self.ratingValue=action;
    //       self.checkIconValue();
    //       self.buttonLoad = false;
    //     })
    //     .catch(function(error) {
    //       self.buttonLoad = false;
    //       //console.log(error.response.data);          
    //       self.tooltipText = error.response.data.errorMessage;
    //       self.show=true;
    //     });
    // },
    // addPreference(action) {
    //   this.buttonLoad = true;
    //   if (action == 1) {
    //     this.setPreference(action,"/set-preference-like/");
    //   } else if (action == -1) {
    //     this.setPreference(action,"/set-preference-dislike/");
    //   } else if (action == 0) {
    //     this.setPreference(action,"/set-preference-remove/");
    //   }
    // }
  }
};
</script>